/**
 * Created by mgoria on 10/31/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingUserContextException = undefined;

var _Exception2 = require('../../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let MissingUserContextException = exports.MissingUserContextException = function (_Exception) {
  _inherits(MissingUserContextException, _Exception);

  function MissingUserContextException() {
    _classCallCheck(this, MissingUserContextException);

    return _possibleConstructorReturn(this, (MissingUserContextException.__proto__ || Object.getPrototypeOf(MissingUserContextException)).call(this, 'Missing user context in the Lambda runtime', 403));
  }

  return MissingUserContextException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/Lambda/Exception/MissingUserContextException.js
// module id = 364
// module chunks = 0